<template>
  <v-flex
    :class="'cell elevation-4 '+cellColor" 
     @click.stop="$emit('reveal', word)"
  >
    <span class="word">{{ word }}</span>
  </v-flex> 
</template>

<style lang="scss">
  .cell {
    position: relative;
    overflow: hidden;
    border: 1px solid #ddd;
    margin: 2.5px;
    border-radius: 4px;
  }
  .word {
    position: absolute;
    width: 100%;
    text-align: center;
    top: 50%;
    height: 16px;
    margin-top: -8px;
    line-height: 16px;
    font-size: 12px;
  }
  @media only screen and (min-width: 640px) {
    .word {
      height: 20px;
      margin-top: -10px;
      line-height: 20px;
      font-size: 14px;
    }
  }
  @media only screen and (min-width: 768px) {
    .word {
      height: 24px;
      margin-top: -12px;
      line-height: 24px;
      font-size: 20px;
    }
  }
  @media only screen and (min-width: 1024px) {
    .word {
      height: 30px;
      margin-top: -15px;
      line-height: 30px;
      font-size: 24px;
    }
  }
</style>

<script>
  export default {
    data: () => ({
      
    }),
    props: ['word', 'type', 'reveal', 'master'],
    computed: {
      cellColor() {
        // is spymaster
        if (this.master && this.reveal) {
          return 'grey lighten-2 grey--text text--lighten-1' 
        }
        if (!this.master && !this.reveal) {
            return 'grey lighten-4';
        }
        if (this.type==='red') {
          return 'red lighten-2'
        } else if (this.type==='blue') {
          return 'blue lighten-2'
        } else if (this.type==='yellow') {
          return 'yellow lighten-2'
        } else if (this.type==='bomb') {
          return 'grey darken-3 white--text'
        }
        
//       'grey lighten-4'   : !reveal, 
//       'red lighten-2'    : reveal && type==='red', 
//       'blue lighten-2'   : reveal && type==='blue', 
//       'yellow lighten-2' : reveal && type==='yellow', 
//       'grey darken-3 white--text' : reveal && type==='bomb', 
     
      }
    }
  }
</script>